import { faXmark } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React from 'react'
import { Form, Modal } from 'react-bootstrap'
import RedRoundBtn from '../../Common_Btn/RedRoundBtn/RedRoundBtn'
import './Pay_For_limited_Time_modal.css'
import { getAge } from '../../../../utils/common'

const Pay_For_limited_Time_modal = ({insuranceData,data,...props}) => {

    const data1 = [
        {
            label: "Pay for 5 years",
            percentage: "45%",
            opted_by: ""
        },
        {
            label: "Pay for 10 years",
            percentage: "45%",
            opted_by: "Opted by 58% of Customers"
        },
        {
            label: "Pay for 15 years",
            percentage: "45%",
            opted_by: ""
        },
        {
            label: "Pay til age of 60 years",
            percentage: "45%",
            opted_by: ""
        },

    ]

    console.log(data,'data data');
    console.log(insuranceData,"insuranceData");
    
    return (
        <section className='Pay_For_limited_Time_modal'>
            <Modal
                {...props}
                size="lg"
                aria-labelledby="contained-modal-title-vcenter"
                centered
                className="Pay_For_limited_Time_modal common_modal"
            >
                <Modal.Header>
                    <Modal.Title>Pay for a limited period of time and enjoy coverage for the full period</Modal.Title>
                    <div className='close_icon_holder' onClick={() => { props?.onHide() }}>
                        <FontAwesomeIcon icon={faXmark} className='close_icon' />
                    </div>
                </Modal.Header>

                <Modal.Body>
                    <div className='content_holder'>

                        <div className='main_content_holder'>

                            <div className='customer_detail_div'>
                                <p className='customer_name'>{data?.name}</p>
                                <p className='customer_age'>{getAge(data?.dob)}</p>
                            </div>

                            <div className='pay_card_holder'>
                                {data1?.map((item) => {
                                    return (
                                        <div className='pay_card'>
                                            <div className='left_side'>
                                                <p className='black_radio'>
                                                    <Form.Check
                                                        type="radio"
                                                        name="name"
                                                        label={item?.label}
                                                    />
                                                </p>
                                            </div>

                                            {item?.opted_by && (
                                                <div className='opted_by_div'>
                                                    <p className='opted_text'>
                                                        {item?.opted_by}
                                                    </p>
                                                </div>
                                            )}


                                            <div
                                                className={`save_upto_div ${item?.opted_by ? "active" : ""}`}
                                            >
                                                <p className='text'>Save upto</p>
                                                <p className='percent'>{item?.percentage}</p>
                                            </div>

                                        </div>
                                    )
                                })}

                            </div>


                            <div className='compare_btn_holder'>
                                <RedRoundBtn btn_name="Save Money Now" />
                            </div>

                        </div>



                    </div>
                </Modal.Body>
            </Modal>
        </section>
    )
}

export default Pay_For_limited_Time_modal
